<template>
  <Bar
    :data="data"
    :options="options"
    :plugins="plugins"
  />
</template>

<script>
import Chart from 'chart.js/auto'
import ChartDataAnnotation from 'chartjs-plugin-annotation'
import { Bar } from 'vue-chartjs'

Chart.register(ChartDataAnnotation)
Chart.defaults.color = 'rgb(75 85 99)'
// Chart.defaults.font.family = 'Lexend'

export default {
  name: 'TimeseriesGraph',
  components: {
    Bar,
  },
  props: {
    dataset: Array, // Array of the data, in the format: { bucket: X (pre-formatted), count: Y }
  },
  emits: [
    // 'on-hover',
  ],
  data() {
    return {
      datapoints: [],
      data: this.updateData(),
      options: this.updateOptions(),
      plugins: [
        ChartDataAnnotation
      ],
    }
  },
  beforeMount() {
    this.updateData()
    this.updateOptions()
  },
  watch: {
    dataset() {
      this.updateData()
    },
  },
  methods: {
    updateData() {
      this.labels = this.dataset?.map((x) => x?.bucket)
      this.datapoints = this.dataset?.map((x) => x?.count)

      this.data = {
        labels: this.labels,
        datasets: [
          {
            data: this.datapoints,
            backgroundColor: '#2dd4bf',
            borderColor: '#2dd4bf',
            borderWidth: 2,
            borderSkipped: false,
          },
        ]
      }
      return this.data
    },
    updateOptions() {
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        borderRadius: 50,
        datasets: {
          bar: {
            barThickness: 15,
            categoryPercentage: 1.0,
          }
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: 6,
            },
            grid: {
              drawOnChartArea: false,
              offset: false,
            },
          },
          y: {
            display: false,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            // enabled: false,
            position: 'nearest',
            interaction: {
              intersect: false,
            },
            // callbacks: {
            //   title: (contextArray) => {
            //     const context = contextArray.find(Boolean)
            //     // TODO: Remove date formatting to `@/helpers/time`.
            //     return context.label + ', ' + this.days[context.dataIndex].getDate() + ' ' + this.days[context.dataIndex].toLocaleString('default', { month: 'short' })
            //   },
            //   label: (context) => {
            //     return context.parsed._custom ? [this.formatter(context.parsed._custom.min), this.formatter(context.parsed._custom.max)] : this.formatter(context.parsed.y)
            //   },
            // },
            external: (context) => {
              // const {chart, tooltip} = context
              this.$emit('on-hover', context)
            },
          },
        },
      }
      return this.options
    },
  },
}
</script>